export const QueryKey = {
	me: 'auth/me',
	attachments: 'attachments',
	userNotifications: 'user-notifications',
	companies: 'companies',
	complaints: 'complaints',
	clients: 'clients',
	contents: 'contents',
	files: 'files',
	contacts: 'contacts',
	accessoryCategories: 'accessory-categories',
	accessories: 'accessories',

	components: 'components',

	attributes: 'attributes',
	attributeValues: 'attribute-values',

	orders: 'orders',
	orderItems: 'order-items',
	offers: 'offers',
	offerItems: 'offer-items',

	shippingMethods: 'shipping-methods',

	products: 'products',
	productTypes: 'product-types',
	productTypeCategories: 'product-type-categories',
	changeStatus: 'change-status',
	duplicate: 'duplicate',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
